import { APIConfiguration } from '@savgroup-front-common/configuration';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants';
import Origin from '@savgroup-front-common/constants/shared/origin';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

import { prepareResponseFailure } from '../../helpers';
import { apiCall } from '../../services';

const ENDPOINT = `${APIConfiguration.claim}claimGroups/${COMMON_QUERY_PARAMS.CLAIM_GROUP_ID}/confirmation`;

export interface SetClaimConfirmationArgs {
  claimGroupId: string;
  payload: {
    phoneNumber?: string;
    mail?: string;
    swornStatement?: boolean;
    generalSalesCondition?: boolean;
    iMEI?: string;
    devicePassword?: string;
    serialNumber?: string;
    invoiceId?: string;
    sourceTokenId?: string;
    issueDate?: Date;
    origin?: string;
    ticketId?: string;
  };
}

const setClaimConfirmationCommand = async ({
  claimGroupId,
  payload: {
    devicePassword,
    generalSalesCondition,
    iMEI,
    invoiceId,
    issueDate,
    mail,
    origin = Origin.MY_ACCOUNT,
    phoneNumber,
    serialNumber,
    sourceTokenId,
    swornStatement,
    ticketId,
  },
}: SetClaimConfirmationArgs): Promise<
  BackResponse<string> | BackResponseFailure
> => {
  const url = ENDPOINT.replace(
    COMMON_QUERY_PARAMS.CLAIM_GROUP_ID,
    claimGroupId,
  );

  try {
    const response = await apiCall<BackResponse<string>>(url, {
      method: SUPPORTED_METHODS.PUT,
      json: {
        devicePassword,
        generalSalesCondition,
        iMEI,
        invoiceId,
        issueDate,
        mail,
        origin,
        phoneNumber,
        serialNumber,
        sourceTokenId,
        swornStatement,
        ticketId,
      },
    });

    return response;
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
};

export default setClaimConfirmationCommand;
